// import React, { useEffect, useState } from 'react';
// import Chip from '@mui/material/Chip';
// import TextField from '@mui/material/TextField';

// const ChipInput = ({ onChipChange, placeholder,question,values,required,minRows }) => {
//   const [inputValue, setInputValue] = useState('');
//   const [chips, setChips] = useState(values || []);

//   const handleKeyDown = (e) => {
//     if (e.key === 'Enter' && inputValue.trim() !== '') {
//       e.preventDefault();
//       setChips([...chips, inputValue.trim()]);
//       setInputValue('');
//       if (onChipChange) {
//         onChipChange([...chips, inputValue.trim()]);
//       }
//     }
//   };

//   const handleChipDelete = (index) => {
//     const newChips = [...chips];
//     newChips.splice(index, 1);
//     setChips(newChips);
//     if (onChipChange) {
//       onChipChange(newChips);
//     }
//   };

  
//   useEffect(() => {
//     setChips(values || []); // Update chips when values prop changes
//   }, [values]);

//   return (
//     <div >
//          <div style={{ margin: '5px', color: '#131F32', fontSize: '14px', fontWeight: '600', lineHeight: '24px' }}>
//         {question} {required && <span style={{ color: 'red' }}>*</span>}
//       </div>
//       <div>
//         {chips.map((chip, index) => (
//           <Chip
//             key={index}
//             label ={ typeof chip === 'object' && chip !== null ? chip.name : chip}
//             onDelete={() => handleChipDelete(index)}
//             variant="outlined"
//             style={{ marginRight: '8px', marginBottom: '8px',marginTop:'5px' }}
//           />
//         ))}
//       </div>
//       <TextField
//         value={inputValue}
//         onChange={(e) => setInputValue(e.target.value)}
//         onKeyDown={handleKeyDown}
//         size='small'
//         minRows={minRows >= 3 ? minRows-1 : 1} 
//         maxRows={minRows+1||1}
//         multiline={minRows >= 3} 
//         placeholder={placeholder || "Press Enter to add a chip"}
//         fullWidth
//         variant="outlined"
//         sx={{
//           width: '100%',
//           marginBottom:'10px',
//           marginTop: '5px',
//           '& label.Mui-focused': {
//             color: '#333',
//           },
//           '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
//             borderColor: '#808080',
//           },
//           borderRadius: '20px',
//         }}
//       />
//     </div>
//   );
// };

// export default ChipInput;








import React, { useEffect, useState } from 'react';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SendIcon from '@mui/icons-material/Send';

const ChipInput = ({ onChipChange, placeholder, question, values, required, minRows }) => {
  const [inputValue, setInputValue] = useState('');
  const [chips, setChips] = useState(values || []);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && inputValue.trim() !== '') {
      e.preventDefault();
      setChips([...chips, inputValue.trim()]);
      setInputValue('');
      if (onChipChange) {
        onChipChange([...chips, inputValue.trim()]);
      }
    }
  };

  const handleChipDelete = (index) => {
    const newChips = [...chips];
    newChips.splice(index, 1);
    setChips(newChips);
    if (onChipChange) {
      onChipChange(newChips);
    }
  };

  const handleSendClick = () => {
    if (inputValue.trim() !== '') {
      setChips([...chips, inputValue.trim()]);
      setInputValue('');
      if (onChipChange) {
        onChipChange([...chips, inputValue.trim()]);
      }
    }
  };

  useEffect(() => {
    setChips(values || []); // Update chips when values prop changes
  }, [values]);

  return (
    <div>
      <div style={{ margin: '5px', color: '#131F32', fontSize: '14px', fontWeight: '600', lineHeight: '24px' }}>
        {question} {required && <span style={{ color: 'red' }}>*</span>}
      </div>
      <div>
        {chips.map((chip, index) => (
          <Chip
            key={index}
            label={typeof chip === 'object' && chip !== null ? chip.name : chip}
            onDelete={() => handleChipDelete(index)}
            variant="outlined"
            style={{ marginRight: '8px', marginBottom: '8px', marginTop: '5px' }}
          />
        ))}
      </div>
      <TextField
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={handleKeyDown}
        size='small'
        minRows={minRows >= 3 ? minRows - 1 : 1}
        maxRows={minRows + 1 || 1}
        multiline={minRows >= 3}
        placeholder={placeholder || "Press Enter to add a chip"}
        fullWidth
        variant="outlined"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SendIcon
                onClick={handleSendClick}
                style={{ cursor: 'pointer' }}
              />
            </InputAdornment>
          ),
        }}
        sx={{
          width: '100%',
          marginBottom: '10px',
          marginTop: '5px',
          '& label.Mui-focused': {
            color: '#333',
          },
          '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#808080',
          },
          borderRadius: '20px',
        }}
      />
    </div>
  );
};

export default ChipInput;

